import { useAppSelector } from '../redux/hooks';
import { weightedSim } from '../services/utils/colorUtils';

export function useSimSettings() {
    const { similarityDisplayMode, weightA } = useAppSelector((s) => s.settings);

    const calcSim = (similarity: [number, number]): number =>
        weightedSim(similarity, weightA);

    return { similarityDisplayMode, weightA, calcSim };
}
